/**
 * Component for handling questions with multiple correct answers
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';

// import third-pary classes
import classNames from 'classnames';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

const CheckBox = ({
  answer
  , change
  , checked
  , loggedInUser
  , userAnswer
}) => {

  // SECURITY: Use userAnswer.correct from server instead of answer.correct
  // answer.correct is undefined for non-admin users
  const isCorrect = userAnswer && userAnswer.correct === true;

  const wrapperClass = classNames(
    '-answer-checkbox answer-wrapper'
    , {
      '-correct': checked && isCorrect
      , '-incorrect': checked && userAnswer && !isCorrect
    }
  )
  const inputClass = classNames(
    "answer-input-display -checkbox"
    , {
      '-selected': checked
      , '-correct': isCorrect
    }
  )
  return (
    <div className={wrapperClass} onClick={() => change(answer._id, checked)}>
      <input
        checked={checked}
        className="answer-input"
        name={answer._id}
        type="checkbox"
        value={answer._id}
      />
      <div className={inputClass}>
        <div className='-icon -unchecked '>
          <div className="fal fa-square fa-xl"/>
        </div>
        <div className='-icon -checked'>
          { isCorrect ?
            <div className=" fas fa-check-square fa-xl"/>
            :
            <div className="fas fa-times-square fa-xl"/>
          }
        </div>
      </div>
      <span htmlFor={answer._id} className=" -content"> {answer.content} { loggedInUser.admin ? <em> &mdash; {answer.correct ? 'correct' : 'wrong'}</em> : null } </span>
    </div>
  )
}

class AnswerCheckboxes extends Base {
  constructor(props) {
    super(props);
    this.state = {
      sortedAnswers: this.props.randomizeOrder ?  filterUtils.randomizeOrder(this.props.answers) : filterUtils.sortByOrderWeight(this.props.answers)
    };
    this._bind('_handleInputChange');
  }

  _handleInputChange(answerId, checked) {
    if(checked) {
      this.props.handleUncheckAnswer(answerId);
    } else {
      this.props.handleCheckAnswer(answerId);
    }
  }

  render() {
    const {
      answers
      , loggedInUser
      , selectedAnswers
      , userAnswersByAnswerId
    } = this.props;

    return (
      <div className="-answer-checkboxes">
        <div className="-instructions">Select all that apply</div>
        {this.state.sortedAnswers.map((answer, i) =>
          <CheckBox
            answer={answer}
            loggedInUser={loggedInUser}
            key={answer._id + i}
            change={this._handleInputChange}
            checked={selectedAnswers.indexOf(answer._id) > -1}
            userAnswer={userAnswersByAnswerId[answer._id]}
          />
        )}
      </div>
    )
  }
}

AnswerCheckboxes.propTypes = {
  answers: PropTypes.array.isRequired
  , handleCheckAnswer: PropTypes.func.isRequired
  , handleUncheckAnswer: PropTypes.func.isRequired
  , loggedInUser: PropTypes.object.isRequired
  , questionId: PropTypes.string
  , randomizeOrder: PropTypes.bool
  , selectedAnswers: PropTypes.array.isRequired
  , userAnswersByAnswerId: PropTypes.object
}

AnswerCheckboxes.defaultProps = {
  questionId: ''
  , randomizeOrder: false
  , userAnswersByAnswerId: {}
}

export default AnswerCheckboxes;



// WEBPACK FOOTER //
// modules/answer/components/AnswerCheckboxes.js.jsx